import services from '../services'
import { reactive } from 'vue'
import { useStore } from 'vuex'
import useNotificationToast from './useNotificationToast'

export default function () {
    
    const stateClients = reactive({
        clients: [],
        loading: {
            clients: false,
        },
    })

    const store = useStore()
    const { error } = useNotificationToast()
    
    function loadClientsWithoutPagination() {

        stateClients.loading.clients = true
        const token = store.getters.getToken

        // a API pagina em 20 por padrão: sem um perPage alto os filtros por cliente
        // ficariam presos nos 20 primeiros
        services.clients.getAll({ params: {
            page: 1,
            perPage: 500,
        }, token })
            .then((response) => {
                stateClients.clients = response.data.clients
            })
            .catch(() => {
                error("Não foi possível carregar os clientes.")
                stateClients.loading.clients = false
            })
            .finally(() => {  stateClients.loading.clients = false })
            
    }

    return {
        stateClients,
        loadClientsWithoutPagination,
    }
}